import React, { useEffect } from 'react';
import { useStyles } from 'components/VideoPlayer/useStyles';
import clsx from 'clsx';
import { CircularProgress } from '@material-ui/core';

function Loading({ isLoading }: { isLoading: boolean }) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.errorContainer, !isLoading && classes.displayNone)}>
      <div className={classes.errorContent}>
        <h1>
          <CircularProgress className={clsx(classes.videoLoadingProgress)} />
        </h1>
      </div>
    </div>
  );
}

export default Loading;
